var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.4148C0 4.62906 4.725 0.000488281 10.6071 0.000488281C16.4893 0.000488281 21.2143 4.62906 21.2143 10.4148C21.2143 19.0933 11.5714 26.5183 11.1857 26.8076C10.9929 26.9041 10.8 27.0005 10.6071 27.0005C10.4143 27.0005 10.2214 26.9041 10.0286 26.8076C9.64286 26.5183 0 19.1898 0 10.4148ZM10.607 14.4646C12.9716 14.4646 14.8885 12.5477 14.8885 10.1831C14.8885 7.81858 12.9716 5.90172 10.607 5.90172C8.24247 5.90172 6.32561 7.81858 6.32561 10.1831C6.32561 12.5477 8.24247 14.4646 10.607 14.4646Z",
    fill: "#FAD762"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.7e3514944112efd2402b7dab8e3228fa.svg";
export { ForwardRef as ReactComponent };